import { getSettingsPath } from './getSettingsPath';
export const getSLAConfigUrl = ({
  inboxId
}) => getSettingsPath(`inboxes/${inboxId}/sla`);